export const FETCH_NEWSLETTERS_REQUEST = 'newsletters/FETCH_NEWSLETTERS_REQUEST';
export const FETCH_NEWSLETTERS_SUCCESS = 'newsletters/FETCH_NEWSLETTERS_SUCCESS';
export const FETCH_NEWSLETTERS_FAILURE = 'newsletters/FETCH_NEWSLETTERS_FAILURE';

export const FETCH_FAVORITES_REQUEST = 'newsletters/FETCH_FAVORITES_REQUEST';
export const FETCH_FAVORITES_SUCCESS = 'newsletters/FETCH_FAVORITES_SUCCESS';
export const FETCH_FAVORITES_FAILURE = 'newsletters/FETCH_FAVORITES_FAILURE';

export const UPDATE_FAVORITES_REQUEST = 'newsletters/UPDATE_FAVORITES_REQUEST';
export const UPDATE_FAVORITES_SUCCESS = 'newsletters/UPDATE_FAVORITES_SUCCESS';
export const UPDATE_FAVORITES_FAILURE = 'newsletters/UPDATE_FAVORITES_FAILURE';

export const INIT_NEWSLETTERS = 'newsletters/INIT_NEWSLETTERS';

export const INIT_FAVORITES = 'newsletters/INIT_FAVORITES';

export const INIT_FAVORITES_UPDATED = 'newsletters/INIT_FAVORITES_UPDATED';

export const fetchNewslettersRequest = (payload = {}) => ({
  type: FETCH_NEWSLETTERS_REQUEST,
  payload,
});
export const fetchNewslettersSuccess = (payload = {}) => ({
  type: FETCH_NEWSLETTERS_SUCCESS,
  payload,
});
export const fetchNewslettersFailure = (payload = {}) => ({
  type: FETCH_NEWSLETTERS_FAILURE,
  payload,
});

export const fetchFavoritesRequest = (payload = {}) => ({
  type: FETCH_FAVORITES_REQUEST,
  payload,
});
export const fetchFavoritesSuccess = (payload = {}) => ({
  type: FETCH_FAVORITES_SUCCESS,
  payload,
});
export const fetchFavoritesFailure = (payload = {}) => ({
  type: FETCH_FAVORITES_FAILURE,
  payload,
});

export const updateFavoritesRequest = (payload = {}) => ({
  type: UPDATE_FAVORITES_REQUEST,
  payload,
});
export const updateFavoritesSuccess = (payload = {}) => ({
  type: UPDATE_FAVORITES_SUCCESS,
  payload,
});
export const updateFavoritesFailure = (payload = {}) => ({
  type: UPDATE_FAVORITES_FAILURE,
  payload,
});

export const initNewsletters = (payload = {}) => ({
  type: INIT_NEWSLETTERS,
  payload,
});

export const initFavorites = (payload = {}) => ({
  type: INIT_FAVORITES,
  payload,
});

export const initFavoritesUpdated = (payload = {}) => ({
  type: INIT_FAVORITES_UPDATED,
  payload,
});
